






















import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({
  name: 'sub-categories'
})

export default class extends Vue {
  @Prop({default: []}) readonly subCategories: Array<object>;

  private filterOpen: boolean = true;
  private filtersToShow: number;
  private filterCollapsed: boolean = false;

  private created(): void {
    this.filtersToShow = 5;
    this.filterCollapsed = this.subCategories.length > this.filtersToShow;
  }

  private toggleFilter(): void {
    this.filterOpen = !this.filterOpen;
  }

  private toggleFilterValueCollapse(): void {
    this.filterCollapsed = !this.filterCollapsed;
  }

  private filterIsVisibleCheck(index): boolean {
    return this.filterCollapsed ? index < this.filtersToShow : true;
  }

  private get sortedSubCategories(): object {
    return this.subCategories.sort((a, b) => {
      return a['position'] - b['position'];
    });
  }
}
